import React, { useEffect, useCallback, useState, Suspense } from "react";
import { UploadVideoProps } from "../../../../../@types/components/uploadAdministrationProps.types";
import { LazyNewVideoFormDialog, LazyVideoPlayerDialog } from "../../../../shared";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import { Button, CardContent, Grid, Tooltip, Card, Chip } from "@material-ui/core";

import PublishIcon from "@material-ui/icons/Publish";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";

import "./uploadVideo.css";
// import { fi } from "date-fns/locale";

const UploadVideo = ({ videoFile, setVideoFile, videoFileUrl, setVideoFileUrl }: UploadVideoProps): JSX.Element => {
	// console.log("VideoFile Initial", videoFile);
	const [videoDialogProps, setVideoDialogProps] = useState({
		openDialog: false,
		title: "",
		isAvailable: false,
		buttonTitle: "Click to Upload",
		textFieldTitle: "Paste a video URL",
		buttonTitleIcon: <PublishIcon />,
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setVideoDialogProps(Object.assign({}, videoDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Confirm",
				name: "confirm",
				callback: () => (videoFile ? null : alert("No file"))
			}
		]
	});
	const [videoPlayerProps, setVideoPlayerProps] = useState({
		openPlayer: false,
		handleClosePlayer: () => {
			setVideoPlayerProps(Object.assign({}, videoPlayerProps, { openPlayer: false }));
		}
	});

	const handleVideoFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { files } = event.target;
		const _videoDialogProps = videoDialogProps;

		if (files && files[0]) {
			// console.log("Files", files[0]);
			setVideoFile(files[0]);
			setVideoFileUrl(URL.createObjectURL(files[0]));
			_videoDialogProps.actions[1].callback = () =>
				files[0] !== null || files[0] === undefined
					? setVideoDialogProps(Object.assign({}, videoDialogProps, { openDialog: false, isAvailable: true }))
					: alert("No file is attached");
			setVideoDialogProps(Object.assign({}, _videoDialogProps));
		}
	};

	// console.log("Video File", videoFile);
	// console.log("Dialog Props", videoDialogProps);

	const handleVideoUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setVideoFile(value);
	};

	const handleOpenVideoUploadDialog = () => {
		setVideoDialogProps(Object.assign({}, videoDialogProps, { openDialog: true }));
	};

	const handleCloseVideoUploadDialog = useCallback(() => {
		setVideoDialogProps(Object.assign({}, videoDialogProps, { openDialog: false }));
	}, [videoDialogProps]);

	const handleVideoDeleteChange = () => null;

	const handleOpenVideoPlayer = () => {
		setVideoPlayerProps(Object.assign({}, videoPlayerProps, { openPlayer: true }));
	};

	const { isAvailable, openDialog } = videoDialogProps;

	// console.log("VideoFile", videoFile);

	return (
		<div className="upload-video">
			<Suspense fallback={<div />}>
				<LazyNewVideoFormDialog
					dialogProps={videoDialogProps}
					handleCloseDialog={handleCloseVideoUploadDialog}
					handleVideoFileChange={handleVideoFileChange}
					handleVideoUrlChange={handleVideoUrlChange}
					videoFile={videoFile}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<LazyVideoPlayerDialog
					videoFile={videoFile}
					videoPlayerProps={videoPlayerProps}
					videoFileUrl={videoFileUrl}
				/>
			</Suspense>
			<div className="card-header">Video Upload</div>
			<Card>
				<CardContent className={videoFile && isAvailable === true ? "card-center" : " card-content"}>
					<Button
						className={
							videoFile && isAvailable === true ? "display-none" : "button-green card-content-bttn"
						}
						onClick={() => handleOpenVideoUploadDialog()}
					>
						<span className="button-label-with-icon" style={{ color: "#ffff" }}>
							Upload
						</span>
						<span>
							<PublishIcon className="button-icon" style={{ color: "#ffff" }} />
						</span>
					</Button>
					{videoFile && isAvailable === true ? (
						<Grid xl={4} lg={4} md={12} sm={12} xs={12}>
							<Tooltip title={"Click to download"} arrow className="video-upload-tooltip">
								<Chip
									label={
										typeof videoFile === "string"
											? shortenFileName(videoFile)
											: videoFile && videoFile.originalname
											? shortenFileName(videoFile.originalname)
											: videoFile.name
											? shortenFileName(videoFile.name)
											: "No files added"
									}
									onDelete={() => handleVideoDeleteChange()}
									onClick={() => downloadFile(videoFile)}
								/>
							</Tooltip>
						</Grid>
					) : null}
				</CardContent>
				<CardContent className="card-content">
					<Button className="button-green card-content-bttn" onClick={() => handleOpenVideoPlayer()}>
						<span className="button-label-with-icon">Play</span>
						<span>
							<VisibilityIcon className="button-icon" />
						</span>
					</Button>
				</CardContent>
			</Card>
		</div>
	);
};

export default UploadVideo;
